// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N0NW","newExpiryDate":"styles_newExpiryDate__21Jip","footer":"styles_footer__3Zvnr"};